class CedreMobileGridToggle {
  constructor(container) {
    this.container = container;
    this.grid = document.getElementById(
      container.dataset.mobileGridTarget,
    );
    this.buttons = Array.from(
      container.querySelectorAll("[data-mobile-grid-columns]"),
    );
    this.storageKey = "cedre-product-grid-mobile-columns";

    if (!this.grid || this.buttons.length === 0) return;

    this.setColumns(this.getStoredColumns(), false);
    this.buttons.forEach((button) => {
      button.addEventListener("click", () =>
        this.setColumns(button.dataset.mobileGridColumns, true),
      );
    });
  }

  getStoredColumns() {
    try {
      return (
        window.localStorage.getItem(this.storageKey) ||
        this.grid.dataset.mobileColumns ||
        "2"
      );
    } catch (error) {
      return this.grid.dataset.mobileColumns || "2";
    }
  }

  setColumns(columns, shouldStore) {
    const normalizedColumns = columns === "1" ? "1" : "2";

    this.grid.dataset.mobileColumns = normalizedColumns;
    this.buttons.forEach((button) => {
      const isActive = button.dataset.mobileGridColumns === normalizedColumns;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-pressed", String(isActive));
    });

    if (!shouldStore) return;

    try {
      window.localStorage.setItem(this.storageKey, normalizedColumns);
    } catch (error) {
      return;
    }
  }
}

const initCedreMobileGridToggle = () => {
  document
    .querySelectorAll("[data-mobile-grid-toggle]")
    .forEach((container) => {
      if (container.dataset.mobileGridToggleInitialized === "true") return;

      container.dataset.mobileGridToggleInitialized = "true";
      new CedreMobileGridToggle(container);
    });
};

document.addEventListener("DOMContentLoaded", initCedreMobileGridToggle);
document.addEventListener("shopify:section:load", initCedreMobileGridToggle);

const cedreProductGridContainer = document.getElementById(
  "ProductGridContainer",
);

if (cedreProductGridContainer) {
  new MutationObserver(initCedreMobileGridToggle).observe(
    cedreProductGridContainer,
    {
      childList: true,
      subtree: true,
    },
  );
}
